import { styled } from '@ori-ui/mui';
export var HeartRoot = styled('span')(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.pink[300],
    fontSize: 0,
    left: '50%',
    opacity: 0.5,
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    transition: 'transform 1000ms ease 0ms, opacity 500ms ease 400ms',
    zIndex: 1
  };
});
export var Animation = styled('div')({
  height: '100%',
  position: 'relative',
  width: '100%'
});
export var Parent = styled('div')({
  height: '100%',
  position: 'relative',
  transition: 'transform 0.175s linear',
  width: '100%',
  zIndex: 10
});
export var Group = styled('div')({
  fontSize: 35
});
//# sourceMappingURL=styles.js.map